export function createReportMentionRepository(config) {
    const { repository, client } = config;
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: ['report', 'mentions', 'find', props],
                async queryFn() {
                    if (props.toIds) {
                        // TODO support server-side "in" filter
                        const responses = await Promise.all(props.toIds.map((toId) => client.user.default.mentionList({
                            ...props,
                            to: toId,
                        })));
                        const mentions = responses.flatMap((response) => response.data.data);
                        return mentions;
                    }
                    const { data: { data: mentions }, } = await client.user.default.mentionList(props);
                    return mentions;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=reportMentionRepository.js.map